import { TYPES } from '../../../types';

const departmentsReducer = (state, action) => {
    switch (action.type) {
        case TYPES.GET_DEPARTMENTS:
            return {
                ...state,
                directiveBoard: action.payload.consejo_directivo || {},
                academicBoard: action.payload.consejo_academico || {},
                studentsBoard: action.payload.consejo_estudiantil || {},
                departments: action.payload.departamentos || [],
                direction: (action.payload.Direcciones && action.payload.Direcciones.length > 0)
                    ? action.payload.Direcciones[0]
                    : (action.payload.departamentos?.find(d => d.titulo && d.titulo.toUpperCase().includes('DIREC')) || action.payload.direccion || null),
            }
        default:
            return state
    }
}

export default departmentsReducer;